import React from "react";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";
import Footer from "src/components/Footer";
import { MobileProps, useIsMobile } from "src/hooks/useIsMobile";

type Props = {
  subtitle?: string;
};

// Read optional ?message= from the URL if subtitle prop not provided
function useQueryMessage(): string | undefined {
  const { search } = useLocation();
  try {
    const params = new URLSearchParams(search);
    return params.get("message") || undefined;
  } catch (e) {
    return undefined;
  }
}

export const ErrorPage: React.FC<Props> = ({ subtitle }) => {
  const { isMobile } = useIsMobile();
  const queryMessage = useQueryMessage();
  const messageText = subtitle || queryMessage || "An error occurred";

  return (
    <Container $isMobile={isMobile}>
      <ErrorContent>
        <ErrorTitle>Error</ErrorTitle>
        <Message>
          <span>{messageText}</span>
        </Message>
      </ErrorContent>
      <StickyFooter />
    </Container>
  );
};

const Container = styled.div<MobileProps>`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ $isMobile }: MobileProps) =>
    $isMobile &&
    css`
      margin: 0;
    `}
`;

const ErrorContent = styled.div`
  max-width: 800px;
  width: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  text-align: center;
`;

const ErrorTitle = styled.p`
  height: 120px;
  line-height: 120px;
  font-size: 80px;
  color: rgb(185, 224, 165);
`;

const Message = styled.p`
  font-family: "Roboto";
  font-style: italic;
  font-size: 40px;
  padding-bottom: 26px;
  span {
    display: block;
    font-style: normal;
    font-weight: 400;
  }
`;

const StickyFooter = styled(Footer)`
  position: sticky;
  margin-top: auto;
`;
